import type { ReactNode } from 'react';
import { Skeleton } from '../Skeleton';

/*
 * Root of every shaped skeleton: a live region (callers and their tests have always found the old
 * LoadingState through role="status") around Skeleton.Group, which carries aria-busy and the one
 * announced label. The live region takes the parent's full width, so a shape still sizes properly
 * inside a centred flex column (items-center would otherwise shrink it to its empty content).
 */
export function ShapeGroup({
  children,
  className,
  label,
}: {
  children: ReactNode;
  className?: string;
  label?: string;
}) {
  return (
    <div role="status" className="w-full">
      <Skeleton.Group className={className} label={label}>
        {children}
      </Skeleton.Group>
    </div>
  );
}
